import {
  conbineHolderList,
  btyHolderRank,
} from "../../config/apiServe/new-rpc.js";
import { filterHash } from "../../utils/filters";
const echarts = require("echarts");
require("echarts/lib/chart/pie");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/legend");
require("echarts/lib/component/legendScroll");

export default {
  props: {
    holderInfo: {},
    device: {
      type: String,
      default: "pc",
    },
  },
  watch: {
    holderInfo: {
      handler() {
        this.selectRange(10);
      },
      deep: true,
    },
  },
  computed: {
    deviceWidth() {
      return document.body.clientWidth;
    },
  },
  data() {
    return {
      option: {},
      num: 10,
      type: "personage",
      holdTotal: 0,
      HolderList: [],
      chartsData: [],
      listParam: [
        {
          match: [
            {
              value: "coins",
              key: "asset_exec",
            },
            {
              value: "16htvcBNSEA7fZhAdLJphDwQRQJaHpyHTp",
              key: "exec",
            },
          ],
          match_one: [
            {
              key: "type",
              value: "contractInternal",
            },
          ],
          sort: [
            {
              key: "frozen",
              ascending: false,
            },
          ],
          range: [
            {
              key: "frozen",
              gt: 0,
            },
          ],
          page: {
            size: 10,
            number: 1,
          },
        },
      ],
      btyParam: [
        {
          page: {
            number: 1,
            size: 10,
          },
        },
      ],
    };
  },
  methods: {
    async selectRange(range) {
      let list = {};
      if (this.type === "personage") {
        this.btyParam[0].page.size = range;
        list = await btyHolderRank(this.btyParam);
      } else {
        this.listParam[0].page.size = range;
        list = await conbineHolderList(this.listParam);
      }
      if (list.error === null) {
        this.dealData(list.result);
        this.holdTotal = 0;
        list.result.forEach((item) => {
          this.holdTotal +=
            this.type === "personage" ? item.total : item.frozen;
        });
      }
      this.drawPie();
    },
    async selectType(type) {
      this.$emit("selectType", type);
      this.holdTotal = 0;
      this.num = 10;
      let list = {};
      if (type === "miner") {
        list = await conbineHolderList(this.listParam);
        if (list.error === null) {
          this.dealData(list.result);
          list.result.forEach((item) => {
            this.holdTotal += item.frozen;
          });
        }
      } else {
        list = await btyHolderRank(this.btyParam);
        if (list.error === null) {
          this.dealData(list.result);
          list.result.forEach((item) => {
            this.holdTotal += item.total;
          });
        }
      }
      this.drawPie();
    },
    dealData(data) {
      this.chartsData = [];
      data.forEach((item) => {
        this.chartsData.push({
          name: item.address,
          value:
            this.type === "miner"
              ? item.frozen / 100000000
              : item.total / 100000000,
        });
      });
    },
    drawPie() {
      if (JSON.stringify(this.holderInfo) === "{}") return;
      let myChart = echarts.init(document.getElementById("myChart"));
      if (this.device === "pc") {
        this.option = {
          tooltip: {
            trigger: "item",
            formatter: "{a} : {b}<br/>持有量 : {c}",
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            top: "45px",
            right: "85px",
            textStyle: {
              color: "#516379",
              width: 400,
              rich: {
                a: {
                  padding: [0, 0, 0, 15],
                  width: 300,
                  align: "left",
                },
                b: {
                  color: "#3666D1",
                },
              },
            },
            formatter: (name) => {
              let percent = 0;
              this.chartsData.forEach((item) => {
                if (item.name === name) {
                  percent = (
                    (item.value * 100) /
                    this.holderInfo.total
                  ).toFixed(2);
                }
              });
              let arr = ["{a|" + name + "}" + "{b|" + percent + " %}"];
              return arr.join();
            },
          },
          series: [
            {
              name: "持有人",
              type: "pie",
              radius: ["68%", "85%"],
              center: ["323px", "170px"],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: "center",
                },
              },
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: this.chartsData,
            },
          ],
        };
      } else {
        this.option = {
          title: {
            text: `最佳${this.num}代币持有人`,
            left: "center",
            top: "25%",
            padding: [24, 0],
            textStyle: {
              color: "#516379",
              fontSize: 12,
              fontWeight: "normal",
              align: "center",
            },
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            top: "55%",
            textStyle: {
              color: "#516379",
              width: "100%",
              rich: {
                a: {
                  padding: [0, 0, 0, 15],
                  width: this.deviceWidth / 2,
                  align: "left",
                },
                b: {
                  color: "#3666D1",
                },
              },
            },
            formatter: (name) => {
              let percent = 0;
              this.chartsData.forEach((item) => {
                if (item.name === name) {
                  percent = (
                    (item.value * 100) /
                    this.holderInfo.total
                  ).toFixed(2);
                }
              });
              let arr = [
                "{a|" + filterHash(name) + "}" + "{b|" + percent + " %}",
              ];
              return arr.join();
            },
          },
          series: [
            {
              name: "持有人",
              type: "pie",
              radius: ["55%", "65%"],
              center: ["50%", "25%"],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: "center",
                },
              },
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: this.chartsData,
            },
          ],
        };
      }
      myChart.setOption(this.option);
      myChart.on("legendselectchanged", (obj) => {
        this.$router.push(`/address/${obj.name}`);
      });
    },
  },
};
